import { Record } from 'immutable'

export class WarehousingWarehouse extends Record({
    id: undefined,
    code: undefined,
    name: undefined,
}) {}
